import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusTechnology, deleteTechnology, getAllTechnologies } from "../../../../api/technology";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    buttonsStyle,
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";

function getData(technologies) {
    let data = []
    for (let i = 0; i < technologies.length; ++i) {
        const elem = {}
        elem.title = getNonEmpty(technologies[i].title)
        elem.description = getNonEmpty(technologies[i].description)
        elem.createdAt = technologies[i].createdAt
        elem.active = technologies[i].active
        elem.id = technologies[i]._id
        data = data.concat(elem)
    }
    return data
}

export default function TechnologyPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [technology, setTechnology] = useState(null);

    useEffect(() => {
        getAllTechnologies()
            .then((res) => {
                setData(getData(res.data));
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get technologies.' })
            })
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item.id === cell);
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle} size="small"
                        onClick={() => history.push('/edit-technology/' + elem.id)}>
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title={elem?.active ? "Deactivate" : "Activate"}>
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setTechnology(elem);
                                    setOpenConfirmDialog(1);
                                }}
                            >
                                {elem?.active ? (
                                    <ToggleOffIcon />
                                ) : (
                                    <ToggleOnIcon style={{ color: "red" }} />
                                )}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setTechnology(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "id", text: "", formatter: buttonFormatter }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Technologies list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-technology")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={`Are you sure you want to ${technology?.active ? "deactivate" : "activate"} this technology?`}
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            changeStatusTechnology(technology.id, !technology?.active)
                                .then((res) => {
                                    alertSuccess({
                                        title: `${technology?.active ? "Deactivate!" : "Activate!"
                                            }`,
                                        customMessage: `Technology ${technology?.active ? "deactivate" : "activate"
                                            } successfully`,
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: `Could not ${technology?.active ? "deactivate" : "activate"
                                            } the technology.`,
                                    });
                                });
                        }}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this technology?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteTechnology(technology.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Technology deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the technology.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}